import { useState, useRef, useEffect, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { AppContext } from "../context/ContenxtAPI";
import Accordion from "react-bootstrap/Accordion";
import arpimg from "../assets/aroN.png";
import Cookies from "js-cookie";

const drawerWidth = 240;

const NavBars = () => {
  const token = Cookies.get("token");
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isOneOffDropdownOpen, setIsOneOffDropdownOpen] = useState(false);
  const [isCoverPlansDropdownOpen, setIsCoverPlansDropdownOpen] =
    useState(false);

  const dropdownRef = useRef(null);

  const handleToggle = () => setIsOpen(!isOpen);
  const handleSelect = () => setIsOpen(false);

  const toggleOneOffDropdown = () => {
    setIsOneOffDropdownOpen(!isOneOffDropdownOpen);
    setIsCoverPlansDropdownOpen(false); // Close other dropdown
  };

  const toggleCoverPlansDropdown = () => {
    setIsCoverPlansDropdownOpen(!isCoverPlansDropdownOpen);
    setIsOneOffDropdownOpen(false); // Close other dropdown
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsCoverPlansDropdownOpen(false);
      setIsOneOffDropdownOpen(false);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleItemClick = (callback, closeDropdown) => {
    closeDropdown(); // Close the dropdown before executing callback
    setTimeout(() => {
      callback();
    }, 500);
  };

  const handleLogout = () => {
    Cookies.remove("token");
  };

  const handlePhoneCall = () => {
    window.location.href = "tel:03301114442";
  };

  const [mobileOpen, setMobileOpen] = useState(false);
  const match140 = useMediaQuery("(max-width:1450px)");
  const match1990 = useMediaQuery("(max-width:1270px)");
  const { BoilerRepaiers, handelview, boilerService } = useContext(AppContext);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  // const navigaters = ['Register', 'ForgetPassword', 'ResetSuccessfully', 'ResetPassword', 'EnterCode','Dashboard','CheckUser'];
  // const navigaters = ['dashboard'];
  // const currentPath = window.location.pathname;
  // const shouldRenderSidebar = !navigaters.includes(currentPath.replace("/", ""));
  // if (!shouldRenderSidebar) {
  //   return null;
  // }

  const drawer = (
    <Box className="sidebar_drawer">
      <List className="ul_menu">
        <Link
          to="/"
          className={location.pathname === "/" ? "active" : "linktag"}
        >
          <ListItem disablePadding>
            <ListItemButton className="Drawer">
              <ListItemText primary="Home" />
            </ListItemButton>
          </ListItem>
        </Link>
        <Link
          to="/About"
          className={location.pathname === "/About" ? "active" : "linktag"}
        >
          <ListItem disablePadding>
            <ListItemButton className="Drawer">
              <ListItemText primary="About" />
            </ListItemButton>
          </ListItem>
        </Link>

        <Accordion className="navAcordions">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Cover Plan &nbsp;{" "}
              <img src={arpimg} alt="icons" className="img_navi" />
            </Accordion.Header>
            <Accordion.Body>
              <Link
                to="/"
                onClick={() => setTimeout(() => {
                  handelview()
                }, 500)}

                className={"linktag linksss"}
              >
                <div className="navResponsiveAccordianItem">Boiler</div>
              </Link>
              <Link
                to="/"
                onClick={() => setTimeout(() => { handelview()}, 500)}
                className={"linktag linksss"}
              >
                <div className="navResponsiveAccordianItem">Boiler+</div>
              </Link>
              <Link
                to="/"
                onClick={() => setTimeout(() => { handelview()}, 500)}
                className={"linktag linksss"}
              >
                <div className="navResponsiveAccordianItem">Heating+</div>
              </Link>
              <Link
                to="/"
                onClick={() => setTimeout(() => { handelview()}, 500)}
                className={"linktag linksss"}
              >
                <div className="navResponsiveAccordianItem">Home+</div>
              </Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Link
          to="/NewBoiler"
          onClick={() =>
            setTimeout(() => {
              boilerService();
            }, 500)
          }
          className={location.pathname === "/NewBoiler" ? "active" : "linktag"}
        >
          <ListItem disablePadding>
            <ListItemButton className="Drawer">
              <ListItemText primary="New Boiler" />
            </ListItemButton>
          </ListItem>
        </Link>
        <Accordion className="navAcordions">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              One-Off Services &nbsp;{" "}
              <img src={arpimg} alt="icons" className="img_navi" />
            </Accordion.Header>
            <Accordion.Body>
              <Link
                to="/OneOffServices"
                onClick={() =>
                  setTimeout(() => {
                    boilerService();
                  }, 500)
                }
                className={
                  location.pathname === "/OneOffServices"
                    ? "active linksss"
                    : "linktag linksss"
                }
              >
                <div className="navResponsiveAccordianItem">Boiler Service</div>
              </Link>
              <Link
                to="/BoilerRepai"
                onClick={() =>
                  setTimeout(() => {
                    BoilerRepaiers();
                  }, 500)
                }
                className={
                  location.pathname === "/BoilerRepai"
                    ? "active linksss"
                    : "linktag linksss"
                }
              >
                <div className="navResponsiveAccordianItem">Boiler Repair</div>
              </Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Link
          to="/Contect"
          className={location.pathname === "/Contect" ? "active" : "linktag"}
        >
          <ListItem disablePadding>
            <ListItemButton className="Drawer">
              <ListItemText primary="Contact" />
            </ListItemButton>
          </ListItem>
        </Link>
        <Link
          to="/Help"
          className={location.pathname === "/Help" ? "active" : "linktag"}
        >
          <ListItem disablePadding>
            <ListItemButton className="Drawer">
              <ListItemText primary="Help & Advice" />
            </ListItemButton>
          </ListItem>
        </Link>
        <div className="all_navbtn">
          <div className="navButtons">
            <Link to="/BookRepair">
              <Button variant="outlined" className="btnrepair">
                Book Repair
              </Button>
            </Link>
            <Link to="/BookRepair">
              <Button
                variant="contained"
                className="btnMui"
                onClick={handlePhoneCall}
              >
                03301114442
              </Button>
            </Link>
          </div>
          {token ? (
            <Accordion className="navAcordions">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Your Account &nbsp;{" "}
                  <img src={arpimg} alt="icons" className="img_navi" />
                </Accordion.Header>
                <Accordion.Body>
                  <Link
                    to="/dashboard"
                    state={{ tab: "Home" }}
                    className={
                      location.pathname === "/dashboard" ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">Your Plan</div>
                  </Link>
                  <Link
                    to="/dashboard"
                    state={{ tab: "payment" }}
                    className="linktag"
                  >
                    <div className="navResponsiveAccordianItem">
                      Payment Details
                    </div>
                  </Link>
                  <Link
                    to="/dashboard"
                    state={{ tab: "contact" }}
                    className="linktag"
                  >
                    <div className="navResponsiveAccordianItem">
                      Contact Details
                    </div>
                  </Link>
                  <Link
                    to="/dashboard"
                    state={{ tab: "boiler" }}
                    className="linktag"
                  >
                    <div className="navResponsiveAccordianItem">
                      Boiler Details
                    </div>
                  </Link>
                  <Link
                    to="/dashboard"
                    state={{ tab: "Documents" }}
                    className="linktag"
                  >
                    <div className="navResponsiveAccordianItem">Documents</div>
                  </Link>
                  <Link
                    to="/dashboard"
                    state={{ tab: "FAQs" }}
                    className="linktag"
                  >
                    <div className="navResponsiveAccordianItem">FAQs</div>
                  </Link>
                  <Link onClick={handleLogout} className="linktag">
                    <div className="navResponsiveAccordianItem">Logout</div>
                  </Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : (
            <Link to="/Login">
              <ListItem disablePadding>
                <ListItemButton className="Drawer ">
                  <ListItemText primary="Login" className="logins mb-1" />
                </ListItemButton>
              </ListItem>
            </Link>
          )}
        </div>
      </List>
    </Box>
  );

  return (
    <div className="navbars" style={{ height: match1990 ? "60px" : "70px" }}>
      <CssBaseline />
      <AppBar component="nav" style={{ height: "100%", zIndex: "100000" }}>
        <Container maxWidth="xl" style={{ height: "100%" }}>
          <Toolbar style={{ height: "100%" }}>
            <Box
              style={{
                display: match1990 ? "flex" : "none",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Box style={{ width: "160px" }}>
                <Link to="/">
                  <img src={logo} alt="" style={{ width: "100px" }} />
                </Link>
              </Box>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                display: match1990 ? "none" : "block",
                alignItems: "center",
              }}
            >
              <Link to="/">
                <Box style={{ width: "120px", marginTop: "10px" }}>
                  <img src={logo} alt="" style={{ width: "100%" }} />
                </Box>
              </Link>
            </Typography>
            <Box
              ref={dropdownRef}
              sx={{
                display: match1990 ? "none" : "flex",
                gap: match140 ? "22px" : "22px",
                alignItems: "center",
              }}
            >
              <Link
                to="/"
                className={location.pathname === "/" ? "active" : "linktag"}
              >
                Home
              </Link>
              <Link
                to="/About"
                className={
                  location.pathname === "/About" ? "active" : "linktag"
                }
              >
                About
              </Link>

              <DropdownButton
                id="dropdown-basic-button"
                title="Cover Plans"
                className="paln_drowp"
                show={isCoverPlansDropdownOpen}
                onClick={toggleCoverPlansDropdown}
              >
                <Dropdown>
                  <Link
                    to="/"
                    onClick={() => setIsCoverPlansDropdownOpen(false)}
                    className="linktag"
                  >
                    Boiler
                  </Link>
                </Dropdown>
                <Dropdown>
                  <Link
                    to="/"
                    onClick={() => setIsCoverPlansDropdownOpen(false)}
                    className="linktag"
                  >
                    Boiler+
                  </Link>
                </Dropdown>
                <Dropdown>
                  <Link
                    to="/"
                    onClick={() => setIsCoverPlansDropdownOpen(false)}
                    className="linktag"
                  >
                    Heating+
                  </Link>
                </Dropdown>
                <Dropdown>
                  <Link
                    to="/"
                    onClick={() => setIsCoverPlansDropdownOpen(false)}
                    className="linktag"
                  >
                    Home+
                  </Link>
                </Dropdown>
              </DropdownButton>

              <Link
                to="/NewBoiler"
                onClick={() =>
                  setTimeout(() => {
                    boilerService();
                  }, 500)
                }
                className={
                  location.pathname === "/NewBoiler" ? "active" : "linktag"
                }
              >
                New Boiler
              </Link>

              <DropdownButton
                id="dropdown-basic-button"
                title="One-Off Services"
                className="paln_drowp"
                show={isOneOffDropdownOpen}
                onClick={toggleOneOffDropdown}
              >
                <Dropdown>
                  <Link
                    to="/OneOffServices"
                    onClick={() =>
                      handleItemClick(boilerService, () =>
                        setIsOneOffDropdownOpen(false)
                      )
                    }
                    className={
                      location.pathname === "/OneOffServices"
                        ? "active"
                        : "linktag"
                    }
                  >
                    Boiler Service
                  </Link>
                </Dropdown>
                <Dropdown>
                  <Link
                    to="/BoilerRepai"
                    onClick={() =>
                      handleItemClick(BoilerRepaiers, () =>
                        setIsOneOffDropdownOpen(false)
                      )
                    }
                    className={
                      location.pathname === "/BoilerRepai"
                        ? "active"
                        : "linktag"
                    }
                  >
                    Boiler Repair
                  </Link>
                </Dropdown>
              </DropdownButton>
              <Link
                to="/Contect"
                className={
                  location.pathname === "/Contect" ? "active" : "linktag"
                }
              >
                Contact
              </Link>
              <Link
                to="/Help"
                className={location.pathname === "/Help" ? "active" : "linktag"}
              >
                Help & Advice
              </Link>
              <div className="ToBtns">
                {token ? (
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Your Account"
                    className="paln_drowp"
                    show={isOpen}
                    onClick={handleToggle}
                  >
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        className={
                          location.pathname === "/dashboard"
                            ? "active"
                            : "linktag"
                        }
                        onClick={handleSelect}
                      >
                        Your Plan
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        state={{ tab: "payment" }}
                        className="linktag"
                        onClick={handleSelect}
                      >
                        Payment Details
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        state={{ tab: "contact" }}
                        className="linktag"
                        onClick={handleSelect}
                      >
                        Contact Details
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        state={{ tab: "boiler" }}
                        className="linktag"
                        onClick={handleSelect}
                      >
                        Boiler Details
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        state={{ tab: "Documents" }}
                        className="linktag"
                        onClick={handleSelect}
                      >
                        Documents
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        to="/dashboard"
                        state={{ tab: "FAQs" }}
                        className="linktag"
                        onClick={handleSelect}
                      >
                        FAQs
                      </Link>
                    </Dropdown>
                    <Dropdown>
                      <Link
                        onClick={() => {
                          handleLogout();
                          handleSelect();
                        }}
                        className="linktag"
                      >
                        Logout
                      </Link>
                    </Dropdown>
                  </DropdownButton>
                ) : (
                  <Link to="/Login" className="login">
                    Login
                  </Link>
                )}

                <Link to="/BookRepair">
                  <Button variant="outlined" className="btnrepair">
                    Book Repair
                  </Button>
                </Link>

                <Link>
                  {" "}
                  <Button
                    variant="contained"
                    className="btnMui"
                    onClick={handlePhoneCall}
                  >
                    03301114442
                  </Button>
                </Link>
              </div>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          anchor="top"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: match1990 ? "block" : "none",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </div>
  );
};

export default NavBars;
